import React, { ChangeEvent, useCallback, useMemo, useState } from 'react'
import { CircleSpinner } from 'react-spinners-kit'
import { ClienteType } from "../../Parametro/Types/ClienteType"
import List, { ListColumn, ListRow, ListSection } from '../../../../../components/List'
import { Link } from 'react-router-dom'
import { Checkbox } from '@mui/material'
import { setListaId } from '../Reducers/ClientsReducer'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../../store/hooks'

type SortField = 'codigo' | 'nome'
type SortDirection = 'asc' | 'desc'

interface Props {
    lista: ClienteType[] | null
    loading: boolean
    check: boolean
}

const TableListarClientes: React.FC<Props> = ({ lista, loading, check }) => {

    const grids = "80px 1fr 1fr 100px 140px"
    const dispatch = useDispatch()
    const {listaIdColeta} = useAppSelector(state => state.ClientsReducer)
    const SHOW_DATA = !!lista && !loading
    const SHOW_LOADING = loading

    const [sortField, setSortField] = useState<SortField>('nome')
    const [sortDirection, setSortDirection] = useState<SortDirection>('asc')

    const handleSort = useCallback((field: SortField) => {
        if (sortField === field) {
            setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc')
        } else {
            setSortField(field)
            setSortDirection('asc')
        }
    }, [sortField])

    const sortedLista = useMemo(() => {
        if (!lista) return null

        return [...lista].sort((a, b) => {
            let comparison = 0

            if (sortField === 'codigo') {
                const codeA = Number(a.codigo) || 0
                const codeB = Number(b.codigo) || 0
                comparison = codeA - codeB
            } else {
                comparison = (a.nome || '').localeCompare(b.nome || '', 'pt-BR', { sensitivity: 'base' })
            }

            return sortDirection === 'asc' ? comparison : -comparison
        })
    }, [lista, sortField, sortDirection])

    const handleEditarCheck = useCallback((Checkbox: ChangeEvent<HTMLInputElement>, idParametro: any) => {
        let novaListaId = [...listaIdColeta!]
 
        if(Checkbox.target.checked) { 
            novaListaId?.push(idParametro)
            
        }else{
            const index = listaIdColeta?.indexOf(idParametro)
            novaListaId.splice(index!, 1)
        }

        dispatch(setListaId([...novaListaId!]))
        
    }, [listaIdColeta,dispatch])

    const renderSortLabel = (label: string, field: SortField) => {
        const isActive = sortField === field
        const arrow = isActive ? (sortDirection === 'asc' ? ' ▲' : ' ▼') : ''

        return (
            <span
                onClick={() => handleSort(field)}
                style={{ cursor: 'pointer', userSelect: 'none' }}
                title={`Ordenar por ${label}`}
            >
                {label}{arrow}
            </span>
        )
    }
    
    
    return (
        <>
            <List name="clients">
                <ListSection type="header">
                    <ListRow grid={grids}>
                        {check && <ListColumn text="" />}
                        <ListColumn>{renderSortLabel('Código', 'codigo')}</ListColumn>
                        <ListColumn>{renderSortLabel('Cliente', 'nome')}</ListColumn>
                        <ListColumn text="Situação" />
                        <ListColumn text="Data de Cadastro" />
                    </ListRow>
                </ListSection>
                <ListSection type="main">
                    {SHOW_LOADING && (
                        <ListRow grid='1fr'>
                            <ListColumn center><CircleSpinner size={32} color="grey" /></ListColumn>
                        </ListRow>
                    )} 
                    {SHOW_DATA && sortedLista?.map((item, index) => (
                        <ListRow key={item.id}  zebra={index % 2 === 0} grid={grids}>
                            {check && <Checkbox checked={listaIdColeta?.includes(item.id)}  onChange={(e) => handleEditarCheck(e, item.id)}  />}
                            <Link to={"/cadastro/cliente/" + item.id.toString()}> <ListColumn text={item.codigo} /></Link>
                            <Link to={"/cadastro/cliente/" + item.id.toString()}><ListColumn text={item.nome} /></Link>
                            <Link to={"/cadastro/cliente/" + item.id.toString()}><ListColumn text={(item.flagAtivo === 0 ? 'Desabilitado' : 'Habilitado')} /></Link>
                            <Link to={"/cadastro/cliente/" + item.id.toString()}><ListColumn text={new Date(item.dtCadastro).toLocaleDateString()} /></Link>
                        </ListRow>
                    ))}
                </ListSection>
            </List>
        </>
    )

}

export default TableListarClientes
